module.exports = __webpack_public_path__ + "static/media/Data_insight_mo_3-4.61f9d14d.svg";